<template>
  <div class="product-bd tb" v-if="funcView.product_code_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.product_code_add && isAdmin">
          <el-button type="primary" icon="el-icon-plus" @click="addProduct">{{ funcView.product_code_add }}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item v-if="funcView.product_code_export" style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 切换项 -->
        <el-form-item style="float: right" v-if="funcView.product_code_lisToBlock">
          <el-button style="vertical-align: top" class="table-set" @click="showCart = !showCart">
            <i style="font-size: 12px" class="icon icon-menu" v-if="!showCart"></i>
            <i style="font-size: 12px" class="icon icon-liebiao" v-else></i>
          </el-button>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_productCode.chan_pin_xing_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_productCode.ISTzhan_dian')">
          <custom-select
            v-model="formSearch.websiteName"
            url="websiteSelectList"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            :props="{ label: 'websiteName', value: 'websiteName' }"
            width="100%"
          ></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd" v-if="!showCart">
      <custom-table height="100%" :data="productList" :column="tableColumn" :index="true" @filter="filterChange" @sort="sortChange" :slots="['lifespan']">
        <template slot="lifespan" slot-scope="scope">
          <el-button type="text" size="mini" @click="openLiftspanDialog(scope.row.productCode)">{{ $t('Common.com_detail') }}</el-button>
        </template>
        <el-table-column :label="$t('Common.com_handle')" min-width="180" fixed="right" v-if="!!tableColumn.length">
          <template slot-scope="scope">
            <el-button v-if="funcView.product_code_edit" type="text" size="mini" @click="editProduct(scope.row.productCodeId)">{{ funcView.product_code_edit }}</el-button>
            <el-button v-if="funcView.product_code_delete && isAdmin" type="text" size="mini" @click="deleteProduct(scope.row)">{{ funcView.product_code_delete }}</el-button>
            <el-button  v-if="funcView.product_code_set_life"  type="text" size="mini" @click="setLiftspanDialog(scope.row.productCode)">{{ funcView.product_code_set_life }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="card-bd" v-if="showCart">
      <ul>
        <li v-for="(item, index) in productList" :key="index">
          <i v-if="isAdmin" @click="deleteProduct(item)" class="btn-del icon icon-shanchu"></i>
          <i :style="{ right: !isAdmin ? '17px' : '' }" @click="editProduct(item.productCodeId)" class="btn-edit icon icon-bianji"></i>
          <div class="img-box">
            <img v-if="getAttachUrl(item)" :src="getAttachUrl(item)" alt />
          </div>
          <div class="product-code">{{ item.productName }}</div>
          <div class="product-sn">{{ item.productCode }}</div>
          <div class="status">{{ propertyMapObj[item.productState] }}</div>
        </li>
      </ul>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <productCode-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getProductList()"></productCode-item-dialog>
    <productCode-lifespan-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></productCode-lifespan-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import productCodeItemDialog from './children/productCode_item_dialog.vue';
import productCodeLifespanDialog from './children/productCode_lifespan_dialog.vue';

export default {
  name: 'productCode',
  mixins: [resetFormSearchMixins],
  components: { productCodeItemDialog, productCodeLifespanDialog },
  data() {
    return {
      provide: true,
      tableCode: 'product_code_manage',
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      productCodeId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        productErpCode: '',
        productErpName: '',
        websiteCode: '',
        country: '',
      },
      showCart: false,
      productList: [],
      totalRows: null,
      isLoading: false,
      propertyMapObj: {},
      showProductInfo: false,
      link: null,
    };
  },
  activated: function () {
    this.getProductList();
  },
  computed: {
    bizType() {
      return this.$store.state.userInfo.bizType;
    },
    isAdmin() {
      return this.$store.state.userInfo.bizType === 'PF';
    },
  },
  // watch: {
  //   bizType: {
  //     immediate: true,
  //     handler(val) {
  //       if (val) {
  //         const isAdmin = this.$store.state.userInfo.bizType === 'PF';
  //         this.tableCode = isAdmin ? 'product_manage' : 'product_factory_manage';
  //         this.getTableColumn();
  //       }
  //     },
  //   },
  // },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getDictionary('dms_product_state', (data) => {
      this.propertyMapObj = this.$transformDicValue(data.dms_product_state || []);
    });
  },
  methods: {
    // 新增
    addProduct() {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'add',
        title: this.$t('dms_productCode.xzcpxh'),
      };
    },
    // 编辑
    editProduct(productCodeId) {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'edit',
        title: this.$t('dms_productCode.bjcpxh'),
        productCodeId,
      };
    },
    openLiftspanDialog(productCode) {
      this.dialogVisible2 = true;
      this.dialogModel2 = {
        type: 'watch',
        title: this.$t('dms_productCode.ckllsmo', [productCode]),
        data: { productCode: productCode },
      };
    },
    setLiftspanDialog(productCode) {
      this.dialogVisible2 = true;
      this.dialogModel2 = {
        type: 'edit',
        title: this.$t('dms_productCode.szllsmo', [productCode]),
        data: { productCode: productCode },
      };
    },
    // 获取产品支持功能
    getSportFunc(row) {
      const { supportFunc } = row;
      if (supportFunc) {
        const arr = supportFunc.split(',');
        const ret = arr.map((str) => this.getDicValue('iot_product_support_func', str));
        return ret.join(',');
      }
      return '';
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.productCodeExport, {}).then(() => {});
    },
    // 获取产品列表
    getProductList: function () {
      this.$getJSON(apis.productCodePage, this.formSearch).then((res) => {
        const list = res.data.list;
        list.forEach((item) => {
          item.cleanWheelParam = item.cleanWheelParam ? JSON.parse(item.cleanWheelParam) : {};
        });
        this.formatAttachList(list, 'productCodeId', 'dms.product.icon').then((result) => {
          this.productList = result;
        });
        this.totalRows = res.data.total;
      });
    },
    // 查看产品详情
    openProductDetail: function (productCodeId) {
      this.productCodeId = productCodeId;
      this.showProductInfo = true;
    },
    // 删除产品
    deleteProduct: function (data) {
      this.$showConfirm(this.$t('dms_productCode.nqdyscxzdcpxhm')).then(() => {
        this.$postJSON(`${apis.productCodeDelete}/${data.productCodeId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success',
          });
          this.getProductList();
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getProductList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.product-bd {
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 400px;
      height: 200px;
      & > div {
        top: 15px;
      }
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 217px;
        height: 288px;
        border-radius: 4px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 16px;
        margin-bottom: 16px;
        position: relative;
        overflow: hidden;
        .btn-del {
          position: absolute;
          color: #0d9ae0;
          font-size: 14px;
          right: 17px;
          bottom: 13px;
          display: block;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #0d9ae0;
          font-size: 14px;
          right: 47px;
          bottom: 13px;
          display: block;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 57px;
          font-size: 14px;
          background-color: #0d9ae0;
          border-bottom-left-radius: 28px;
          text-align: right;
          padding-right: 10px;
        }
        .img-box {
          $r: 160px;
          width: $r;
          height: $r;
          position: relative;
          margin-top: 32px;
          margin-left: auto;
          margin-right: auto;
          img {
            position: absolute;
            max-width: 100%;
            max-height: 100%;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .product-code {
          margin-top: 20px;
          color: #0d9ae0;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          line-height: 22px;
        }
        .product-sn {
          font-size: 14px;
          color: #495057;
          line-height: 20px;
          position: absolute;
          left: 16px;
          bottom: 11px;
        }
      }
    }
  }
}
</style>
